import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  const [lang, setLang] = useState("ro");

  // Try to relocate the platform "Made with Emergent" badge into our footer slot
  useEffect(() => {
    let observer;
    let attempts = 0;

    const findBadgeRoot = () => {
      // Find the element whose own text is exactly "Made with Emergent"
      const all = document.querySelectorAll("a, button");
      for (const el of all) {
        const txt = (el.textContent || "").trim().toLowerCase();
        if (txt === "made with emergent") return el;
      }
      return null;
    };

    const findFixedAncestor = (node) => {
      let cur = node;
      let depth = 0;
      while (cur && cur !== document.body && depth < 5) {
        const cs = window.getComputedStyle(cur);
        if (cs.position === "fixed") return cur;
        cur = cur.parentElement;
        depth++;
      }
      return null;
    };

    const tryMove = () => {
      attempts++;
      const slot = document.getElementById("emergent-badge-slot");
      if (!slot) return false;
      const badge = findBadgeRoot();
      if (!badge) return false;
      const fixedWrap = findFixedAncestor(badge);
      // Only move the fixed wrapper (the floating pill). If we can't find one, leave it.
      if (!fixedWrap) return false;
      // Safety: never move body / root / ancestors of slot
      if (
        fixedWrap === document.body ||
        fixedWrap.id === "root" ||
        fixedWrap.contains(slot)
      )
        return false;
      // Hide instead of moving if anything looks off
      try {
        fixedWrap.style.position = "static";
        fixedWrap.style.inset = "auto";
        fixedWrap.style.zIndex = "auto";
        fixedWrap.style.margin = "0";
        slot.appendChild(fixedWrap);
        return true;
      } catch {
        return false;
      }
    };

    // Try a few times right after mount
    const initial = setInterval(() => {
      if (tryMove() || attempts > 20) clearInterval(initial);
    }, 250);

    observer = new MutationObserver(() => {
      if (tryMove()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      clearInterval(initial);
      observer && observer.disconnect();
    };
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home lang={lang} setLang={setLang} />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
